import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { FormattedDate, injectIntl, intlShape, FormattedMessage } from 'react-intl';

import {
  isEndOfLifeStatus,
  isLiveStatus,
  isProblemStatus,
  isTrialStatus
} from '../../helpers/subscription';
import Warning from '@material-ui/icons/Warning';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/ErrorOutline';

import { blue, orange, red } from '@material-ui/core/colors';
import SubscriptionListItem from './SubscriptionListItem';

const styles = theme => ({
  icon: {
    //marginRight: theme.spacing.unit,
    width: 48
  },
  status: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  captionColor: {
    color: '#A1A1A1'
  }
})

/**
 * Subscription status view, with text and icon
 */
const SubscriptionStatus = ({
  intl,
  subscription,
  classes,
  displayPaymentInfo = false,
  displayIcon = false
}) => {
  return (
    <SubscriptionListItem
      left={
        <SubscriptionStatusIcon
          className={classes.icon}
          subscription={subscription} />
      }
    >
      <div>
        <Typography variant="caption" className={classes.captionColor}>
          <FormattedMessage id='subscription.status.label' />
        </Typography>
        <Typography>
          {displayIcon && <SubscriptionStatusIcon subscription={subscription} fontSize />}
          <FormattedMessage id={`subscription.status.${subscription.status}`} />
        </Typography>
      </div>
    </SubscriptionListItem>
  );
}

export default withStyles(styles)(
  injectIntl(SubscriptionStatus)
);

/**
 * Subscription status icon 
 */
export const SubscriptionStatusIcon = ({ subscription, ...props }) => {
  if (isEndOfLifeStatus(subscription.status)) {
    return <Error {...props} nativeColor={red[500]} />
  }
  if (isProblemStatus(subscription.status)) {
    return <Warning {...props} nativeColor={orange[500]} />;
  }
  // live and ok
  if (isLiveStatus(subscription.status)) {
    return <CheckCircle {...props} nativeColor={blue[500]} />;
  }
}

/**
 * Subscription status details, 
 * ie either trial expiration date or current period end date
 */
const SubscriptionStatusDetailsView = ({ subscription, intl, classes }) => {
  return isTrialStatus(subscription.status)
    ? (
      <Grid item sm xs={12}>
        <Typography
          variant="caption"
          className={classes.captionColor}>
          <FormattedMessage id='subscription.trialExpirationDate.label' />
        </Typography>
        <Typography>
          <FormattedDate
            value={subscription.trialExpirationDate} />
        </Typography>
      </Grid>
    )
    : (
      <Grid item sm xs={12}>
        <Typography variant="caption"
          className={classes.captionColor}>
          <FormattedMessage id='subscription.currentPeriodEndDate.label' />
        </Typography>
        <Typography>
          <FormattedDate
            value={subscription.currentPeriodEndDate} />
        </Typography>
      </Grid>
    )
}

SubscriptionStatusDetailsView.propTypes = {
  subscription: PropTypes.object.isRequired,
  intl:intlShape
};

export const SubscriptionStatusDetails = injectIntl(
  withStyles(styles)(SubscriptionStatusDetailsView)
  );


// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionStatus.js